










import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Undo extends Vue {
  @Prop()
  transform: string;

  undo() {
    this.$store.dispatch("undo");
  }
}
